import React from 'react';
import { formatPhoneNumber } from "../../../helpers/formatting";

export default class TransferFailure extends React.Component {
    constructor(props) {
        super(props);
    }

    tryAgain = (e) => {
        e.preventDefault();
        if (this.props.resetStep) {
            this.props.resetStep(e, false);
        }
    }
    getDrugInfo(rxNumber) {
        const drugInfo = this.props.getDrugInfo(rxNumber);
        if (!drugInfo.ndcImageURL || drugInfo.ndcImageURL === "")
            drugInfo.ndcImageURL = '/images/prescription_placeholder.jpg';
        return drugInfo;
    }

    render() {
        const { sourcePharmacy, failedRxs, notAllowedRxs} = this.props;

        if (!failedRxs && !notAllowedRxs) return null;

        const phoneNumber = sourcePharmacy && sourcePharmacy.PhoneNumber ? formatPhoneNumber(sourcePharmacy.PhoneNumber) : null;

        return (
            <div className="col-12 confirm-rx-list-container transfer-failure">
                {failedRxs && failedRxs.Prescriptions.length > 0 &&
                    <div className="confirm-rx-list">
                    {failedRxs.Prescriptions.map((item) => {
                        const drugInfo = this.getDrugInfo(item.RxNumber);
                        return (<div key={item.RxNumber} className="confirm-rx-list__item">
                                    <div className="rx-img-container">
                                        <div className="confirm-rx-list__img">
                                            <img src={drugInfo.ndcImageURL} alt={drugInfo.drugName + " photo"} className="img-responsive" />
                                        </div>
                                    </div>
                                    <div className="confirm-rx-list__info">
                                        <div>{drugInfo.drugName}</div>
                                        <div>RX No. {item.RxNumber}</div>
                                    </div>
                                </div>);
                        })}
                        <div className="rx-confirmation-status-msg failed-rx details-icon-prepend">
                            <div className="icon-col">
                                <span className="icon-error" /> 
                            </div>
                            <div className="details-col">
                                This request did not go through. Please call your pharmacy
                                {sourcePharmacy &&
                                    <React.Fragment>
                                        {' '}at
                                        <span>
                                            {' '}<a className="phone-link" href={"tel:" + phoneNumber}>{phoneNumber}</a>
                                        </span>
                                    </React.Fragment>
                                }
                                {' or '} <a href="#" onClick={this.tryAgain}>try again</a>{'.'}
                            </div>
                        </div>
                    </div>
                }
                {notAllowedRxs && notAllowedRxs.Prescriptions.length > 0 &&
                    <div className="confirm-rx-list">
                        {notAllowedRxs.Prescriptions.map((item) =>
                            (<div key={item.RxNumber}>
                                <div className="confirm-rx-list__item">
                                    <div className="confirm-rx-list__img">
                                        <img alt={getDrugName(item.RxNumber) + " photo"} src="/images/prescription_placeholder.jpg" className="img-fluid" />
                                    </div>
                                    <div className="confirm-rx-list__info">
                                        <div>{getDrugName(item.RxNumber)}</div>
                                        <div>RX No. {item.RxNumber}</div>
                                    </div>
                                </div>
                            </div>)
                        )}
                        <div className="rx-confirmation-status-msg not-allowed-rx details-icon-prepend">
                            <div className="icon-col">
                                <span className="icon-error" />
                            </div>
                            <div className="details-col">
                                This prescription cannot be transferred. Please call your pharmacy
                                 {sourcePharmacy &&
                                    <React.Fragment>
                                        {' '}at
                                        <span>
                                            {' '}<a className="phone-link" href={"tel:" + phoneNumber}>{phoneNumber}</a>
                                        </span>
                                    </React.Fragment>
                                }
                                {' or '} <a href="#" onClick={this.tryAgain}>try again</a>{'.'}
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}